import config from './firebase-config'
import firebase from 'firebase/app'
import 'firebase/firebase-auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/firebase-functions'

firebase.initializeApp(config)

const Auth = firebase.auth()
const GoogleProvider = new firebase.auth.GoogleAuthProvider();

const Storage = firebase.storage()

// Used for accessing field values
const FirestoreRef = firebase.firestore

const Firestore = firebase.firestore()
const Functions = firebase.app().functions() // 'europe-west1'

// Functions.useFunctionsEmulator('http://localhost:5001')

export { Auth, Storage, Firestore, FirestoreRef, GoogleProvider, Functions }
